import { Component, inject, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    standalone: true,
    imports: [ButtonModule, ConfirmDialogModule, ToastModule],
    providers: [ConfirmationService]
})
export class ConfirmDialogComponent {
    private confirmationService = inject(ConfirmationService);

    message = input('Por favor confirme para proceder.');
    header = input('Tem a certeza?');

    onAcceptDialog = output<void>();

    open(): void {
        this.confirmationService.confirm({
            message: this.message(),
            header: this.header(),
            accept: () => this.onAcceptDialog.emit(),
        });
    }
}